export default "__VITE_ASSET__Bhqvq5Ix__"